module.exports = __webpack_public_path__ + "img/save5.cc9a8d97.png";